import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { Icon } from "../components/Icon";

export function DashboardLayout() {
  const { session, signOut, isDemo } = useAuth();
  return (
    <div className="dashboard-layout">
      <aside className="dashboard-nav">
        <div className="dashboard-brand"><strong>RSM</strong><span>Booking Desk</span></div>
        <nav aria-label="Dashboard navigation">
          <NavLink end to="/dashboard"><Icon name="calendar" /> Agenda</NavLink>
          <NavLink to="/dashboard/availability"><Icon name="clock" /> Availability</NavLink>
          <NavLink to="/dashboard/event-types"><Icon name="settings" /> Meeting types</NavLink>
        </nav>
        <div className="dashboard-account">
          <span>{isDemo ? "Preview mode" : session?.user.email}</span>
          <button type="button" onClick={() => void signOut()}>Sign out</button>
        </div>
      </aside>
      <div className="dashboard-main"><Outlet /></div>
    </div>
  );
}
